<template>
  <div v-on:contextmenu.prevent>
    <v-menu offset-y offset-overflow>
      <template v-slot:activator="{  on: { click, keydown }, value, attrs }">
        <v-card
          tile outlined
          class="v-btn d-flex justify-start pl-5"
          v-bind="attrs"
          v-bind:color="$_timelineTitleContainerColor"
          v-bind:height="timelineHeightPx"
          v-on:keydown="$_onKeydown(value, keydown, click, $event)"
          v-on:click.left="$_onClick(click, $event)"
        >
          <div class="timeline-data-id-indicator">{{ visibleTimelineDataId }}</div>
          <v-card-text class="flex-grow-1 text-truncate pa-0">{{ timelineTitle }}</v-card-text>
          <v-card-actions class="flex-grow-0">
            <v-btn
              icon outlined x-small
              v-on:keydown.space.stop
              v-on:keydown.enter.stop
              v-on:click.stop="$_toggleLockOrUnlockTimeline(visibleTimelineDataId)"
              v-bind:disabled="timelineReadonly"
            >
              <v-icon v-if="timelineLocked || timelineReadonly">mdi-lock</v-icon>
              <v-icon v-else>mdi-lock-open</v-icon>
            </v-btn>
            <v-btn
              icon outlined x-small
              v-bind:disabled="timelineLocked || timelineReadonly"
              v-on:keydown.space.stop
              v-on:keydown.enter.stop
              v-on:click.stop="$_emitToggleSetOrUnsetRealtimeSegmentCreationTarget(visibleTimelineDataId)"
            >
              <v-icon>mdi-record</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
      <v-list dense>
        <v-list-item
          v-for="(menuContent, menuContentIdx) in menuContents"
          v-bind:key="menuContentIdx"
          v-bind:disabled="menuContent.disabled"
          v-on:click.left="menuContent.callback(visibleTimelineDataIdx)"
        >
          <v-list-item-title>{{ menuContent.name }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<style scoped>
.timeline-data-id-indicator:before {
  content: '[';
}

.timeline-data-id-indicator {
  position: absolute;
  top: 0;
  left: 0;
  font-size: 9pt;
}

.timeline-data-id-indicator:after {
  content: ']';
}
</style>

<script>
export default {
  props: {
    visibleTimelineDataId:           { type: String, default: '' },
    visibleTimelineDataIdx:          { type: Number },
    timelineTitle:                   { type: String, default: '' },
    timelineHeightPx:                { type: Number },
    timelineReadonly:                { type: Boolean, default: false },
    timelineLocked:                  { type: Boolean, default: false },
    isRealtimeSegmentCreationTarget: { type: Boolean },
    menuContents:                    { type: Array },
  },

  computed: {
    $_timelineTitleContainerColor() {
      if (this.isRealtimeSegmentCreationTarget) {
        return '#ff9494';
      } else {
        return '#f3f3f3';
      }
    },
  },

  inject: [
    'lockTimeline',
    'unlockTimeline',
  ],

  methods: {
    $_toggleLockOrUnlockTimeline(timelineDataId) {
      if (this.timelineLocked) {
        this.unlockTimeline(timelineDataId);
      } else {
        this.lockTimeline(timelineDataId);
      }
    },

    $_emitSelectAllVisibleSegments() {
      this.$emit('select-all-visible-segments', this.visibleTimelineDataIdx);
    },

    $_emitToggleSetOrUnsetRealtimeSegmentCreationTarget(visibleTimelineDataId) {
      this.$emit('toggle-set-or-unset-realtime-segment-creation-target', visibleTimelineDataId);
    },

    $_onClick(onClickCallback, event) {
      if (event.shiftKey) {
        this.$_emitSelectAllVisibleSegments();            
      } else {
        onClickCallback(event);
      }
    },

    $_onKeydown(isMenuOpen, onKeydownCallback, onClickCallback, event) {
      if (isMenuOpen) {
        onKeydownCallback(event);
      } else {
        switch (event.code) {
        case 'Enter':
        case 'Space':
          if (event.shiftKey) {
            this.$_emitSelectAllVisibleSegments();
          } else {
            onClickCallback(event);
          }
          break;
        }
      }
    },
  }
};
</script>
